import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/Button.jsx';

/**
 * 404. Offers a way forward rather than apologising — the two catalogue
 * entrances and the search, which between them cover why anyone lands here.
 */
export const NotFound = () => (
  <>
    <Helmet>
      <title>Page not found — Golden Era</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <section className="mx-auto grid min-h-[70vh] max-w-(--container-content) place-items-center px-6">
      <div className="max-w-lg text-center">
        <p className="font-mono text-2xs tracking-[0.16em] text-muted uppercase">404</p>
        <h1 className="mt-3 font-display text-3xl tracking-[-0.02em] text-ink">
          There is nothing at this address
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          The page may have moved, or the link may have been typed slightly wrong. Both catalogues
          are one click away.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          <Button to="/shop?world=fragrance">Browse fragrance</Button>
          <Button to="/shop?world=sport" variant="outline">
            Browse sport
          </Button>
        </div>

        <p className="mt-8 text-xs text-muted">
          Looking for an order?{' '}
          <Link to="/orders/track" className="text-ink underline decoration-mist underline-offset-4 hover:decoration-ink">
            Track it here
          </Link>
          .
        </p>
      </div>
    </section>
  </>
);

export default NotFound;
